import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Form Input Uang Tips ", -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "error-summary" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Keterangan", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Jumlah Uang", -1)
const _hoisted_10 = { class: "card-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorSummary, (err, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(err), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
            class: "custom-select",
            autocomplete: "off",
            placeholder: "Keterangan"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listReason, (val, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: 'list-reason-' + index,
                value: val
              }, _toDisplayString(val), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_money3, _mergeProps({
            modelValue: _ctx.amountDebit,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amountDebit) = $event)),
            modelModifiers: { number: true }
          }, _ctx.config, { class: "form-control" }), null, 16, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "btn btn-light",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.btnBatalClicked && _ctx.btnBatalClicked(...args)))
      }, "Batal"),
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveUangTips && _ctx.saveUangTips(...args)))
      }, _toDisplayString(_ctx.btnSaveText), 1)
    ])
  ]))
}